import * as React from "react";
import { useMemo, useState, useEffect } from "react";
import DataTable from "components/common/DataTable";
import PaginatedList from "components/common/PaginatedList";
import Filter from "./Filter";
const DEFAULT_PAGINATION = {
  page: 1,
  perPage: 10,
  query: ""
};
const _paginatedRows = (rows, perPage, currentPage) => {
  const begin = perPage * (currentPage - 1);
  const end = begin + perPage;
  return rows.slice(begin, end);
};
const PaginatedDataTable = ({
  rows: rowsProp,
  pagination: initialPagination = DEFAULT_PAGINATION,
  filterKeys = void 0,
  id,
  useResponsiveTable = false,
  hover = void 0,
  ...rest
}) => {
  const rows = useMemo(() => rowsProp != null ? rowsProp : [], [rowsProp]);
  const [{ perPage, page }, setPagination] = useState(initialPagination);
  const [filteredRows, setFilteredRows] = useState(rows);
  const paginatedRows = _paginatedRows(filteredRows, perPage, page);
  useEffect(() => {
    setFilteredRows(rows);
    setPagination(initialPagination);
  }, [rows, initialPagination]);
  const _onPageChange = (newPage, newPerPage) => {
    setPagination({ page: newPage, perPage: newPerPage });
  };
  const _resetPagination = () => {
    setPagination({ perPage, page: initialPagination.page });
  };
  return /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      totalItems: filteredRows.length,
      pageSize: perPage,
      activePage: page,
      onChange: _onPageChange,
      showPageSizeSelect: true,
      useQueryParameter: false
    },
    /* @__PURE__ */ React.createElement(
      DataTable,
      {
        ...rest,
        useResponsiveTable,
        id,
        customFilter: /* @__PURE__ */ React.createElement(
          Filter,
          {
            id,
            filterKeys,
            setFilteredRows,
            rows,
            resetPagination: _resetPagination
          }
        ),
        rows: paginatedRows
      }
    )
  );
};
export default PaginatedDataTable;
